module.exports = __webpack_public_path__ + "img/tw.faa48f64.svg";